import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams } from "react-router-dom"

import { useState } from "react"
import UsersList from "./UsersList"
//import { useGetGroupsQuery } from "../groups/groupsApiSlice"
function UsersListFilter() {
    useTitle('geshtop-Exercise: Users List')
    const {groupId} = useParams()
  //   const { groups } = useGetGroupsQuery("groupsList", {
  //     selectFromResult: ({ data }) => ({
  //         groups: data?.ids.map(id => data?.entities[id])
  //     }),
  // })
  const[txt,setTxt] = useState('')
  // const [filterGroup, setFilterGroup] = useState('')
//   if (!groups?.length) return <PulseLoader color={"#FFF"} />
   
//   const options = groups.map(group => {
//     return (
//         <option
//             key={group.id}
//             value={group.id}
//         > {group.name} - {group.year} - {group.companyname}</option >
//     )
// })
   

    const content =(<>
    <div className="filter-form">
        <div className="filter-form-item">
            <div className="form-input-container">
            <input
                    className={`form__input`}
                    id="txt"
                    placeholder="הכנס שם, תעודת זהות, מייל או טלפון לחיפוש"
                    name="txt"
                    type="text"
                    autoComplete="off"
                    value={txt}
                    onChange={e=>setTxt(e.target.value)}
                />
             </div>
        </div>
        {/* <div className="filter-form-item">
            <div className="form-input-container">
            <select
                        id="filterGroup"
                        name="filterGroup"
                        className={`form__input`}
                        value={filterGroup}
                        onChange={(e)=>setFilterGroup(e.target.value)}
                    >
                        <option></option>
                        {options}
                    </select>
             </div>
        </div> */}
    </div>
  <UsersList txt={txt}  /> 

</> ) 
  return content;
}

export default UsersListFilter